import { useReducer } from 'react';
import {
    SortingOrder,
    type WebPageFilteringRule,
    WebPageSortingField,
    type WebPageSortingRule,
} from '../../../api/types';
import {
    type ExtendedPageState,
    type ExtendedPageAction,
    extendedReducer,
} from '../../../components/PaginatedTableWithContext';
import { TableSortingOrder, type SortOrderValue } from '../../../utilities/useSortAndFilterCache';

type SortRule = WebPageSortingRule & SortOrderValue;
type State = ExtendedPageState & {
    filter: WebPageFilteringRule;
    sort: SortRule;
};

export type SetSortAction = { type: 'setSort'; sort: SortRule };

export type SetFilterAction = { type: 'setFilter'; filter: WebPageFilteringRule };

export type Action = ExtendedPageAction | SetSortAction | SetFilterAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'setFilter':
            return { ...state, page: 1, filter: action.filter };

        case 'setPage':
            return { ...state, page: action.page };

        case 'setPageSize':
            return { ...state, page: 0, pageSize: action.pageSize };

        case 'setSort':
            return { ...state, page: 1, sort: action.sort };

        default:
            return extendedReducer(state, action);
    }
};

const useListReducer = (cache?: State) =>
    useReducer(reducer, {
        companyId: cache?.companyId,
        // default pagination
        page: cache?.page || 1,
        pageSize: cache?.pageSize || 10,

        // default sorting
        sort: cache?.sort || {
            field: WebPageSortingField.IsActive,
            order: SortingOrder.Asc,
            orderValue: TableSortingOrder.Asc,
        },

        filter: cache?.filter || {},
    });

export default useListReducer;
